<template>
  <v-card class="mx-auto">
    <v-card-title>
      {{ id ? "Edit User" : "Create User" }}
      <v-spacer></v-spacer>
      <v-btn plain @click="close"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pt-6 ">
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="user.firstName"
              label="First Name"
              :rules="[rules.required, rules.noNumbers]"
              dense
          /></v-col>
          <v-col cols="12" md="6"
            ><v-text-field
              v-model="user.lastName"
              label="Last Name"
              :rules="[rules.required, rules.noNumbers]"
              dense
          /></v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6"
            ><v-text-field
              v-model="user.username"
              label="User Name"
              :rules="[rules.required]"
              dense
          /></v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="user.email"
              label="Email"
              :rules="[rules.required, rules.emailMatch]"
              dense
          /></v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="user.phone"
              type="number"
              label="Phone"
              :rules="[rules.phoneMatch]"
          /></v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="userModules"
              label="User's module"
              multiple
              chips
              :items="availableModules"
              item-text="name"
              item-value="id"
              dense
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="userRoles"
              label="User roles"
              multiple
              chips
              :items="groupedRoles"
              item-text="name"
              item-value="id"
              dense
              :rules="[rules.required]"
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="userLocations"
              dense
              multiple
              chips
              label="Authorized Locations"
              :items="availableLocations"
              item-text="name"
              item-value="id"
              :rules="[rules.required]"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="mb-5">
      <v-btn @click="close" large plain color="primary">Cancel</v-btn>
      <v-spacer />

      <v-btn @click="handleSubmit" color="primary" class="px-10" rounded large>
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import { getAccountModules } from "@/services/module";
import { getAccountRoles } from "@/services/accountServices.js";
import { getUser } from "@/services/user";
import { rules } from "../../utils/validation";
export default {
  props: ["id", "isModal"],
  data() {
    return {
      userId: null,
      rules,
      user: {
        firstName: "",
        lastName: "",
        username: "",
        phone: "",
        email: "",
      },
      userModules: [],
      availableModules: [],
      userRoles: null,
      availableRoles: [],
      userLocations: null,
      availableLocations: [],
      account: null,
      editPassword: false,
      tabs: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    groupedRoles() {
      //filter roles selected by user's modules
      return this.userModules.length
        ? this.availableRoles.filter(
            r => r.moduleId == null || this.userModules.includes(r.moduleId),
          )
        : this.availableRoles.filter(r => r.moduleId == null);

      //group items in v-select

      // const clone = [...filteredRoles];
      // clone.sort((r1, r2) => (r1.moduleName > r2.moduleName ? 1 : -1));
      // const results = [];
      // let cursor = null;
      // clone.forEach(r => {
      //   if (!cursor || cursor != r.moduleName) {
      //     results.push({ header: r.moduleName });
      //     cursor = r.moduleName;
      //   }
      //   results.push(r);
      // });
      // return results;
    },
    filteredUserRoles() {
      const groupedRolesIds = this.groupedRoles.map(role => role.id);
      return this.userRoles.filter(role => groupedRolesIds.includes(role));
    },
  },
  methods: {
    ...mapActions("user", ["createUser", "updateUser"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),
    async fetchData() {
      const allModulesPromise = await getAccountModules();
      const allRolesPromise = await getAccountRoles();
      const allLocationPromise = await this.$axios("/account/get-locations");

      const [allModules, allRoles, allLocation] = await Promise.all([
        allModulesPromise,
        allRolesPromise,
        allLocationPromise,
      ]);
      this.availableModules = allModules.data.content;
      this.availableRoles = allRoles;
      this.availableLocations = allLocation.data;

      if (this.id) {
        const userDataPromise = await getUser(this.id);
        const userModulesPromise = await this.$axios("/user/module", {
          params: { user_id: this.id },
        });
        const userRolesPromise = await this.$axios("/user/roles", {
          params: { user_id: this.id },
        });
        const userLocationPromise = await this.$axios("/user/locations", {
          params: { user_id: this.id },
        });

        const [
          fetchedUserData,
          fetchedUserModules,
          fetchedUserRoles,
          fetchedUserLocation,
        ] = await Promise.all([
          userDataPromise,
          userModulesPromise,
          userRolesPromise,
          userLocationPromise,
        ]);

        this.user = {
          relations: {},
          firstName: fetchedUserData.data.firstName,
          lastName: fetchedUserData.data.lastName,
          username: fetchedUserData.data.username,
          phone: fetchedUserData.data.phone,
          email: fetchedUserData.data.email,
        };
        this.userModules = fetchedUserModules.data.map(module => module.id);
        this.userRoles = fetchedUserRoles.data.map(role => role.id);
        this.userLocations = fetchedUserLocation.data.map(
          location => location.id,
        );
      }
    },
    async handleSubmit() {
      if (!this.$refs.form.validate()) return;
      if (this.id || this.userId) {
        try {
          const id = this.id ? this.id : this.userId;
          const userUpdateData = { ...this.user, id };
          //res object should return from BE, then res.id should assign into this.userId
          await this.updateUser(userUpdateData);
          this.userId = this.id;
        } catch (err) {
          this.addErrorMessage("Error updating User, please try again later");
        }
      } else {
        try {
          const res = await this.createUser(this.user);
          this.userId = res.id;
        } catch (err) {
          this.addErrorMessage("Error creating User, please try again later");
        }
      }

      if (this.userId) {
        try {
          const userModuleData = {
            userId: this.userId,
            moduleIds: this.userModules ? this.userModules : [],
          };
          const userRoleData = {
            userId: this.userId,
            roleIds: this.filteredUserRoles ? this.filteredUserRoles : [],
          };

          const userLocationData = {
            userId: this.userId,
            locationIds: this.userLocations ? this.userLocations : [],
          };

          const saveUserModulePromise = await this.$axios.post(
            "/user/module",
            userModuleData,
          );
          const saveUserRolePromise = await this.$axios.post(
            "/user/role",
            userRoleData,
          );
          const saveUserLocationPromise = await this.$axios.post(
            "/user/location",
            userLocationData,
          );

          await Promise.all([
            saveUserModulePromise,
            saveUserRolePromise,
            saveUserLocationPromise,
          ]);

          if (this.id) {
            this.addSuccessMessage("User was updated successfully");
          } else {
            this.addSuccessMessage("User was created successfully");
          }
          this.close();
        } catch (err) {
          if (this.id) {
            this.addErrorMessage("Error updating User, please try again later");
          } else {
            this.addErrorMessage("Error creating User, please try again later");
          }
        }
      }
    },
    close() {
      this.$emit("closeUserDialog");
      this.$refs.form.reset();
    },
  },
};
</script>
